import {
    WebinarInfoCustom,
    WebinarInfoInterface, WebinarInfoInterpretation,
    WebinarInfoYouTube,
    WebinarInfoZoom
} from "@api/models/interfaces/WebinatInfoInterface";
import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";

export class WebinarInfo implements WebinarInfoInterface {
    onlineProvider: OnlineProvider = OnlineProvider.empty;
    usersOnlineCount = 0;
    youTube: WebinarInfoYouTube = {};
    custom: WebinarInfoCustom = {};
    zoom: WebinarInfoZoom = {};
    simulInterpretation: WebinarInfoInterpretation = {};

    constructor(data: WebinarInfoInterface) {
        Object.assign(this, data);
    }
}